var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.750002 2.2575C0.750002 1.4235 1.4235 0.75 2.2575 0.75H21.75C22.5818 0.75 23.25 1.428 23.25 2.2575V15.75C23.25 16.5817 22.572 17.25 21.7425 17.25H2.2575C2.05945 17.2503 1.86329 17.2115 1.68026 17.1359C1.49722 17.0602 1.33092 16.9492 1.19088 16.8091C1.05083 16.6691 0.939804 16.5028 0.86415 16.3197C0.788496 16.1367 0.749705 15.9406 0.750002 15.7425V2.2575ZM2.25 2.25375V2.6265L7.0125 5.661C6.73101 6.07989 6.5037 6.53274 6.336 7.00875L2.25 4.40475V14.01L6.465 11.3243C6.65955 11.7872 6.91153 12.2239 7.215 12.624L2.31 15.75H21.7013L16.7835 12.6202C17.0871 12.2197 17.3391 11.7825 17.5335 11.319L21.75 14.0033V4.41L17.661 7.0125C17.4938 6.53632 17.267 6.08322 16.986 5.664L21.75 2.63325V2.25225L21.747 2.25H2.25375L2.2515 2.2515L2.25075 2.253L2.25 2.25375Z",
    fill: "url(#paint0_linear_108_568)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_568",
    x1: 12,
    y1: 0.75,
    x2: 12,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF961A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1908"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail3);
export default __webpack_public_path__ + "static/media/email3.24eb65363357aca967f05218d1d0a738.svg";
export { ForwardRef as ReactComponent };